export enum MENU_CLASSES {
    ONLY_FOR_TOP = 'only-for-top',
    ONLY_FOR_LEFT = 'only-for-left',
    ONLY_FOR_RIGHT = 'only-for-right',
    NOT_FOR_LEFT = 'not-for-left',
    NOT_FOR_RIGHT = 'not-for-right',
    IS_HEADER_TWO_BTN = 'is-header-two-btn',
    IS_HEADER_LOGIN_BTN = 'is-header-login-btn',
    IS_HEADER_BTN_PRIMARY = 'is-header-btn-primary',
    IS_HEADER_ALWAYS_SHOW_BTN = 'is-header-always-show-btn',
    IS_HEADER_REGISTRATION_BTN = 'is-header-registration-btn',

    HIDDEN = 'hidden',
    IS_PAGE_BG = 'isPageBg',
    IS_LOGOUT = 'is-logout',
    NO_LOGO_MODAL = 'no-logo-modal',
    SHOW_BINGO_LOBBY = 'show-BingoLobby',
    SHOW_THIRD_LEVEL = 'show-third-level',
    SHOW_CHAT_GUEST = 'show-chat-for-guest',
    HIDDEN_FOR_SITEMAP = 'hidden-for-sitemap',
    WHITE_POPUP_BG = 'white-popup-background',
    IS_LOGIN_AND_REG_BTN = 'isLoginAndJoinNowButtons'
}
